export const SANDBOX_SIDEBAR_MENU_HOME = "ffb_sandbox_sidebar_menu_home";
export const SANDBOX_SIDEBAR_MENU_MONEY_TRANSFER = "ffb_sandbox_sidebar_menu_money_transfer";
export const SANDBOX_SIDEBAR_MENU_MONEY_TRANSFER_NEW = "ffb_sandbox_sidebar_menu_money_transfer_new";
export const SANDBOX_SIDEBAR_MENU_MONEY_TRANSFER_TRANSACTION_HISTORY =
  "ffb_sandbox_sidebar_menu_money_transfer_transaction_history";
export const SANDBOX_SIDEBAR_MENU_MONEY_TRANSFER_TRANSACTION_REPORT =
  "ffb_sandbox_sidebar_menu_money_transfer_transaction_report";

export const SANDBOX_SIDEBAR_MENU_INTERNATIONAL_TRANSFER = "ffb_sandbox_sidebar_menu_international_transfer";
export const SANDBOX_SIDEBAR_MENU_INTERNATIONAL_TRANSFER_NEW = "ffb_sandbox_sidebar_menu_international_transfer_new";
export const SANDBOX_SIDEBAR_MENU_INTERNATIONAL_TRANSFER_TRANSACTION_HISTORY =
  "ffb_sandbox_sidebar_menu_international_transfer_transaction_history";

export const SANDBOX_SIDEBAR_MENU_ACCEPT_PAYMENT = "ffb_sandbox_sidebar_menu_accept_payment";
export const SANDBOX_SIDEBAR_MENU_ACCEPT_PAYMENT_NEW = "ffb_sandbox_sidebar_menu_accept_payment_new";
export const SANDBOX_SIDEBAR_MENU_ACCEPT_PAYMENT_HISTORY = "ffb_sandbox_sidebar_menu_accept_payment_history";

export const SANDBOX_SIDEBAR_MENU_DEVELOPER_MENU = "ffb_sandbox_sidebar_menu_developer_menu";
export const SANDBOX_SIDEBAR_MENU_DEVELOPER_MENU_MANAGE_API = "ffb_sandbox_sidebar_menu_developer_menu_manage_api";
export const SANDBOX_SIDEBAR_MENU_DEVELOPER_MENU_ACCOUNT_INQUIRY_HISTORY =
  "ffb_sandbox_sidebar_menu_developer_menu_account_inquiry_history";
export const SANDBOX_SIDEBAR_MENU_DEVELOPER_MENU_VERIFICATION_HISTORY =
  "ffb_sandbox_sidebar_menu_developer_menu_verification_history";

export const SANDBOX_SIDEBAR_MENU_HELP_CENTER = "ffb_sandbox_sidebar_menu_help_center";
